import React, { useState, useEffect, useRef } from "react";
import { styled, keyframes } from "styled-components";
import { Link } from "gatsby";
import { gsap } from "gsap";
import { graphql, useStaticQuery } from "gatsby";

//assets
import logo from "assets/svg/logo.svg";

// Styles
import colors from "styles/colors.js";
import typographySizes from "styles/typographySizes.js";
import mediaQuery from "styles/mediaQuery.js";
import distances from "styles/distances.js";

// Components
import Btn from "components/global/Btn.js";

// Keyframe for entrance animation - slide down from top
const slideDownEntrance = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`;

const Wrapper = styled(Link)`
  background-color: ${colors.yellow};
  height: 3rem;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  position: relative;
  text-decoration: none;
  z-index: 1000;
  /* Entrance animation */
  animation: ${slideDownEntrance} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s both;
  
  &:hover {
    background-color: ${colors.dark};
    span{
      color: ${colors.yellow};
    }
  }
`;

const ScrollingContainer = styled.div`
  display: flex;
  white-space: nowrap;
  will-change: transform;
`;

const Text = styled.span`
  font-size: ${typographySizes.text.small.size.desktop}rem;
  color: ${colors.dark};
  text-transform: uppercase;
  padding-right: 1rem; /* Space between repeated text */
  padding-left: 1rem;
  flex-shrink: 0;
`;

const InfoBar = () => {
  const scrollContainerRef = useRef(null);
  const textRef = useRef(null);

  const data = useStaticQuery(graphql`
    query InfoBarQuery {
      strapiGlobal {
        Top_text
        Top_text_url
      }
    }
  `);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const textElement = textRef.current;

    if (!scrollContainer || !textElement) return;

    // Wait for entrance animation to complete, then start infinite scroll
    const timer = setTimeout(() => {
      // Get the width of a single text element
      const textWidth = textElement.offsetWidth;

      // Create the infinite scroll animation
      gsap.set(scrollContainer, { x: 0 });

      gsap.to(scrollContainer, {
        x: -textWidth,
        duration: 4, // Adjust speed here (lower = faster)
        ease: "none",
        repeat: -1,
      });
    }, 700); // 0.2s delay + 0.5s duration

    return () => clearTimeout(timer);
  }, []);

  const textContent = data.strapiGlobal.Top_text;

  return (
    data.strapiGlobal.Top_text && (
      <Wrapper
        id="info-bar"
        to={data.strapiGlobal.Top_text_url}
        target="_blank"
      >
        <ScrollingContainer ref={scrollContainerRef}>
          <Text ref={textRef}>{textContent} &nbsp;&nbsp; &nbsp; //</Text>
          {Array.from({ length: 12 }, (_, index) => (
            <Text key={index}>{textContent} &nbsp;&nbsp; &nbsp; //</Text>
          ))}
        </ScrollingContainer>
      </Wrapper>
    )
  );
};

export default InfoBar;
